import styled from 'styled-components';

export const VerificationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 327px;
`;

export const VerificationTitle = styled.h2`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.36px;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontPrimary : '#152946'};
  margin: 0;
  text-align: center;
  width: 100%;
`;

export const VerificationSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontSecondary : '#777e91'};
  margin: 0;
  text-align: center;
  width: 100%;
`;
